import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const Profile10 = () => {
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Meera Krishnan',
        email: 'meera@example.com',
        phone: '+91 98765 43210',
        address: {
            street: '42 Lotus Lane',
            city: 'Chennai',
            state: 'Tamil Nadu',
            pincode: '600001',
        },
    });

    const handleInputChange = (name, value) => {
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData(prev => ({
                ...prev,
                [parent]: { ...prev[parent], [child]: value },
            }));
        } else {
            setProfileData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    const inputClass = "w-full px-0 py-3 bg-transparent text-[#1C1917] text-sm font-light focus:outline-none transition-colors duration-300";

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-10 md:py-16 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <h1 className="text-2xl md:text-3xl font-light text-[#1C1917] tracking-tight">Profile</h1>
                    </div>

                    <div className="max-w-[600px] mx-auto px-5 md:px-8 py-8 md:py-12">
                        {/* Avatar & Name */}
                        <div className="text-center mb-10">
                            <div className="w-16 h-16 bg-[#FAFAF9] flex items-center justify-center mx-auto mb-4" style={{ border: '1px solid #E7E5E4' }}>
                                <span className="text-[#78716C] text-lg font-light">
                                    {profileData.fullName.split(' ').map(n => n[0]).join('')}
                                </span>
                            </div>
                            <p className="text-[#1C1917] text-base font-light">{profileData.fullName}</p>
                            <p className="text-[#A8A29E] text-xs font-light mt-1">{profileData.email}</p>
                        </div>

                        {/* Profile Fields */}
                        <div className="mb-8">
                            <div className="flex justify-between items-center mb-6">
                                <p className="text-[#1C1917] text-xs tracking-[2px] uppercase">Personal Details</p>
                                <button
                                    onClick={() => isEditing ? handleSave() : setIsEditing(true)}
                                    className="text-[#78716C] text-xs font-light underline underline-offset-4 hover:text-[#1C1917] transition-colors bg-transparent border-none cursor-pointer"
                                >
                                    {isEditing ? 'Save' : 'Edit'}
                                </button>
                            </div>

                            {[
                                { label: 'Full Name', name: 'fullName', value: profileData.fullName },
                                { label: 'Email', name: 'email', value: profileData.email },
                                { label: 'Phone', name: 'phone', value: profileData.phone },
                            ].map((field) => (
                                <div key={field.name} className="py-3" style={{ borderBottom: '1px solid #E7E5E4' }}>
                                    <p className="text-[#A8A29E] text-[10px] tracking-[1px] uppercase mb-1">{field.label}</p>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            value={field.value}
                                            onChange={(e) => handleInputChange(field.name, e.target.value)}
                                            className={inputClass}
                                            style={{ fontFamily: "'Inter', sans-serif" }}
                                        />
                                    ) : (
                                        <p className="text-[#1C1917] text-sm font-light">{field.value}</p>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Address */}
                        <div className="mb-8">
                            <p className="text-[#1C1917] text-xs tracking-[2px] uppercase mb-6">Address</p>
                            {[
                                { label: 'Street', name: 'address.street', value: profileData.address.street },
                                { label: 'City', name: 'address.city', value: profileData.address.city },
                                { label: 'State', name: 'address.state', value: profileData.address.state },
                                { label: 'Pincode', name: 'address.pincode', value: profileData.address.pincode },
                            ].map((field) => (
                                <div key={field.name} className="py-3" style={{ borderBottom: '1px solid #E7E5E4' }}>
                                    <p className="text-[#A8A29E] text-[10px] tracking-[1px] uppercase mb-1">{field.label}</p>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            value={field.value}
                                            onChange={(e) => handleInputChange(field.name, e.target.value)}
                                            className={inputClass}
                                            style={{ fontFamily: "'Inter', sans-serif" }}
                                        />
                                    ) : (
                                        <p className="text-[#1C1917] text-sm font-light">{field.value}</p>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Quick Links */}
                        <div className="space-y-0 mb-10">
                            {[
                                { label: 'Your Orders', path: '/template10/orders' },
                                { label: 'Shipping & Returns', path: '/template10/shipping-exchange' },
                                { label: 'FAQs', path: '/template10/faqs' },
                            ].map((link) => (
                                <button
                                    key={link.label}
                                    onClick={() => navigate(link.path)}
                                    className="w-full flex justify-between items-center py-4 text-[#1C1917] text-sm font-light hover:text-[#78716C] transition-colors bg-transparent border-none cursor-pointer"
                                    style={{ borderBottom: '1px solid #E7E5E4' }}
                                >
                                    {link.label}
                                    <span className="text-[#A8A29E]">&rarr;</span>
                                </button>
                            ))}
                        </div>

                        {/* Sign Out */}
                        <button
                            onClick={() => navigate('/template10/login')}
                            className="w-full flex items-center justify-center gap-2 py-3 text-[#78716C] text-xs tracking-[2px] uppercase font-light hover:text-[#1C1917] transition-colors bg-transparent cursor-pointer"
                            style={{ border: '1px solid #E7E5E4' }}
                        >
                            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} />
                            Sign Out
                        </button>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Profile10;
